import { chakra } from '@chakra-ui/react';
import React from 'react';

import type { AddressParamBasic } from 'types/api/addressParams';

import { Container, Link, Content, Copy } from 'ui/shared/entities/address/AddressEntity';

type Props = {
  entryPoint: string | AddressParamBasic;
  entryPointVersion?: string | null;
  isLoading?: boolean;
  truncation?: 'constant' | 'constant_long' | 'constant_tokens' | 'dynamic' | 'tail' | 'none';
};

const EntryPointEntity = ({ entryPoint, entryPointVersion, isLoading, truncation = 'constant' }: Props) => {
  const addressParam = typeof entryPoint === 'string' ? { hash: entryPoint } : entryPoint;

  return (
    <Container
      display="flex"
      alignItems="center"
      gap="4px"
      minW={ 0 }
    >
      <Link address={ addressParam } isLoading={ isLoading } minW={ 0 }>
        <Content
          address={ addressParam }
          isLoading={ isLoading }
          truncation={ truncation }
        />
        <chakra.span color="inherit" fontSize="inherit" lineHeight="inherit" flexShrink={ 0 }>
          { `\u00A0${ entryPointVersion || '-' }` }
        </chakra.span>
      </Link>
      <Copy address={ addressParam } isLoading={ isLoading }/>
    </Container>
  );
};

export default EntryPointEntity;
